export default __webpack_public_path__ + "static/media/logo_RS.e398fa47.svg";